import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';

import { UPDATE_NIGHT } from 'nights/api/apollo/mutations';
import { LIST_NIGHTS, SINGLE_NIGHT } from 'nights/api/apollo/queries';

const withUpdateNight = Component => (
  @withRouter
  @graphql(UPDATE_NIGHT, { name: 'updateNight' })
  class Wrapper extends PureComponent {
    static propTypes = {
      name: PropTypes.string,
      updateNight: PropTypes.func,
      match: PropTypes.shape({
        params: PropTypes.shape({
          night: PropTypes.number,
          locale: PropTypes.string,
        }),
      }),
    };

    updateNight = (data) => {
      const { updateNight, match: { params: { night: n, locale } } } = this.props;
      const night = Number(n);
      data.night = night;
      data.locale = locale;
      return updateNight({
        variables: { data },
        refetchQueries: [
          { query: SINGLE_NIGHT, variables: { night }, },
          { query: LIST_NIGHTS }
        ]
      });
    };

    render() {
      const { updateNight, ...rest } = this.props;
      return (
        <Component {...rest} updateNight={this.updateNight} />
      );
    }
  }
);

export default withUpdateNight;
